import { useEffect, useState } from 'react';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

const getDeviceType = (width: number): DeviceType => {
    if (width < 768) return 'mobile';
    if (width < 992) return 'tablet';
    return 'desktop';
};

export const useMediaQuery = () => {
    const [device, setDevice] = useState<DeviceType>(() =>
        typeof window !== 'undefined'
            ? getDeviceType(window.innerWidth)
            : 'desktop'
    );

    useEffect(() => {
        const onResize = () => {
            setDevice(getDeviceType(window.innerWidth));
        };

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return {
        device,
        isMobile: device === 'mobile',
        isTablet: device === 'tablet',
        isDesktop: device === 'desktop',
    };
};
